import { useShop } from "../lib/shop";

export const StockBadge = ({ product, threshold }) => {
    const { settings } = useShop();
    const t = threshold ?? settings.low_stock_threshold;
    const variations = product?.variations || [];
    let stock = product?.stock;
    if (variations.length) {
        stock = variations.reduce((n, v) => n + (v.stock || 0), 0);
    }
    if (stock === null || stock === undefined) return null;
    if (stock <= 0)
        return (
            <span className="inline-block rounded-full bg-red-100 text-red-700 text-xs font-bold px-3 py-1" data-testid="stock-out">
                Out of stock
            </span>
        );
    if (stock <= t)
        return (
            <span className="inline-block rounded-full bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1" data-testid="stock-low">
                Only {stock} left in stock
            </span>
        );
    return null;
};
